import "./last.css";
import React from "react";
const Last = () => {
  return (<div className="l">
       <div className="bg-container">
         <h1 className="l-title">
          hai domande relative <br />
          ai nostri prodotti?
         </h1>
         <a href="https://www.instagram.com/chaniru.lk/" class="myButton-yt">contattaci</a>
       </div>
  </div>
  );
};

export default Last;
